import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Section from "./components/section";
import Card from "./components/Card";
import ContactForm from "./components/ContactForm";
import { wpData } from "./data/wpAPI";
import { LogoMask } from "./hooks/logoMask";

function App() {
  const [wpContent, setWpContent] = useState([]);
  const [wpProjects, setWpProjects] = useState([]);

  // Fetch WP Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const rawData = await wpData("pages");
        const rawProjData = await wpData("project");
        setWpContent(rawData);
        setWpProjects(rawProjData);
      } catch (error) {
        console.error("Error fetching WordPress Data:", error);
      }
    };
    fetchData();
  }, []);
  // const reversed = [...wpContent].reverse();

  LogoMask(wpContent);

  return (
    <>
      <a href="#main-content" className="screen-reader-text">
        Skip to Main Content
      </a>
      <Header />
      <main id="main-content">
        <h1 className="screen-reader-text">Bem-vindos à Keidge.com</h1>
        {wpContent.map(
          (page) =>
            page.id === 6 &&
            page.status === "publish" && (
              <Section
                key={page.id}
                slug={page.slug}
                title={page.title.rendered}
                content={page.content.rendered}
                wrapperClass={"full-width"}
              />
            ),
        )}
        {wpContent.map(
          (page) =>
            page.status === "publish" &&
            page.parent === 6 &&
            page.id !== 11 && (
              <Section
                content={page.content.rendered}
                key={page.id}
                slug={page.slug}
                title={page.title.rendered}
                template={page.template}
              />
            ),
        )}
        <section id="portfolio" className="page-yellow">
          <div className="wrapper full-width">
            <div className="content-wrapper">
              <hgroup>
                <h2>O que fazemos</h2>
                <hr />
              </hgroup>
              <div className="portfolio-grid">
                {wpProjects.map(
                  (project) =>
                    project.status === "publish" && (
                      <Card
                        content={project.content.rendered}
                        featImgId={project.featured_media}
                        key={project.id}
                        title={project.title.rendered}
                      />
                    ),
                )}
              </div>
            </div>
          </div>
        </section>
        {wpContent.map(
          (page) =>
            page.status === "publish" &&
            page.id === 11 && (
              <Section
                content={page.content.rendered}
                key={page.id}
                slug={page.slug}
                title={page.title.rendered}
                template={page.template}
              />
            ),
        )}
        <section id="contatos">
          <div className="wrapper full-width">
            <div className="content-wrapper">
              <hgroup>
                <h2>Contatos</h2>
                <hr />
              </hgroup>
              <div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
export default App;
